import type { GetServerSidePropsContext } from 'next';

import { getRequestUser } from 'helpers/get-request-user';

const redirectAnonymous = async ({ req, resolvedUrl }: Pick<GetServerSidePropsContext, 'req' | 'resolvedUrl'>) => {
    const user = await getRequestUser(req);

    if (user) {
        return null;
    }

    const search = new URLSearchParams({
        title: 'Login to access this page',
        redirect: resolvedUrl,
    });

    return {
        redirect: {
            destination: `/login?${search}`,
            permanent: false,
        },
    };
};

export { redirectAnonymous };
